/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q1Inputs */

const es_marketplace_seo_spain_faq_q1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto cuesta alquilar un barco en España?`)
};

const gl_marketplace_seo_spain_faq_q1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto custa aluguer un barco en España?`)
};

const en_marketplace_seo_spain_faq_q1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does it cost to rent a boat in Spain?`)
};

/**
* | output |
* | --- |
* | "How much does it cost to rent a boat in Spain?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q1 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q1(inputs)
	return es_marketplace_seo_spain_faq_q1(inputs)
});